export default function($) {
  const timelineSwiper = new Swiper('.js-timeline-slider', {
    slidesPerView: 1,
    spaceBetween: 32,
    centeredSlides: true,
    navigation: {
      enabled: false,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        navigation: {
          enabled: true,
        },
      },
    },
  });

  const reviewsSwiper = new Swiper('.js-reviews-slider', {
    slidesPerView: 1,
    spaceBetween: 32,
    navigation: {
      enabled: false,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      enabled: true,
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
        navigation: {
          enabled: false,
        },
        pagination: {
          enabled: true,
        }
      },
      1024: {
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        spaceBetween: 0,
        navigation: {
          enabled: false,
        },
        pagination: {
          enabled: true,
        }
      },
      1280: {
        slidesPerView: 'auto',
        slidesPerGroup: 2,
        spaceBetween: 0,
        navigation: {
          enabled: true,
        },
        pagination: {
          enabled: false,
        },
      },
    },
  });

  // Benefits sliders

  let benefitsSwiper = document.querySelector('.js-benefits-slider');

  const benefitsSwiperParams = {
    slidesPerView: 1,
    spaceBetween: 24,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
      enabled: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
        pagination: {
          enabled: true,
        }
      },
    },
    on: {
      destroy: function() {
        $('.swiper-pagination').hide();
      },
      init: function() {
        $('.swiper-pagination').show();
      },
    },
  }

  function benefitsSwiperDisplay(e) {
    if( $(window).width() < 1024 ) {
      if( $('.js-benefits-slider').length > 0 && !benefitsSwiper.initialized ) {
        benefitsSwiper = new Swiper('.js-benefits-slider', benefitsSwiperParams);
      };
    }
    else {
      if( $('.js-benefits-slider').length > 0 && benefitsSwiper.initialized ) {
        benefitsSwiper.destroy(false,true);
        $('.js-benefits-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('#benefits-swiper-pagination').hide();
      };

    }

  }

  // Features Blocks sliders

  var init = false;

  function featuresSwiperDisplay() {
    let featuresSlidersBlock = $('.js-feature-block');

    featuresSlidersBlock.each(function(index) {
      $(this).attr('id', 'js-feature-block-' + index);
      $(this).find('.js-feature-icon-mobile:first').removeClass('opacity-40');
    })

    const buildFeaturesSlider = function(index, elem) {
      return new Swiper(elem, {
        slidesPerView: 1,
        spaceBetween: 24,
        pagination: {
          el: '#js-feature-block-' + index + ' .swiper-pagination',
          clickable: true,
          enabled: true,
        },
        on: {
          slideChange: function() {
            $('#js-feature-block-' + index + ' .js-feature-icon-mobile').addClass('opacity-40');
            var currentSlideIndex = this.activeIndex;
            var nextIconIndex = (currentSlideIndex + 1) % $('#js-feature-block-' + index + ' .js-feature-icon-mobile').length;
            if (nextIconIndex === 0) {
              nextIconIndex = $('#js-feature-block-' + index + ' .js-feature-icon-mobile').length - 1;
            } else {
              nextIconIndex--;
            }
            $('#js-feature-block-' + index + ' .js-feature-icon-mobile').eq(nextIconIndex).removeClass('opacity-40');
          }
        },
    });
    }

    if($(window).width() <= 1024) {
       if (!init) {
        init = true;

        featuresSlidersBlock.each(function(index) {
          let sliderDiv = $(this).find('.js-features-slider')[0]
          const slider = buildFeaturesSlider(index, sliderDiv)
        })
      }
    }
    if ($(window).width() > 1024) {
      featuresSlidersBlock.each(function() {
        let sliderDiv = $(this).find('.js-features-slider')[0]

        if (sliderDiv.swiper) {
          sliderDiv.swiper.destroy(false,true);
        }
      })
      init = false;
    }
  }

  // Related posts sliders

  let relatedPostsSwiper = document.querySelector('.js-related-posts-slider');

  const relatedPostsSwiperParams =  {
    slidesPerView: 1.1,
    spaceBetween: 24,
    pagination: {
      el: "#related-posts-swiper-pagination",
      clickable: true,
      enabled: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 24,
        pagination: {
          enabled: true,
        }
      },
    },
    on: {
      destroy: function() {
        $('.swiper-pagination').hide();
      },
      init: function() {
        $('.swiper-pagination').show();
      },
    },
  };

  function relatedPostsSwiperDisplay(e) {
    if( $(window).width() < 1024 ) {
      if( $('.js-related-posts-slider').length > 0 && !relatedPostsSwiper.initialized ) {
        relatedPostsSwiper = new Swiper('.js-related-posts-slider', relatedPostsSwiperParams);
      };
    }
    else {
      if( $('.js-related-posts-slider').length > 0 && relatedPostsSwiper.initialized ) {
        relatedPostsSwiper.destroy(false,true);
        $('.js-related-posts-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('#related-posts-swiper-pagination').hide();
      };
    }
  }

  // Latest-posts sliders

  let latestPostsSwiper = document.querySelector('.js-latest-posts-slider');

  const latestPostsSwiperParams = {
    slidesPerView: 1.1,
    spaceBetween: 24,
    pagination: {
      enabled: false,
      el: "#latest-posts-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        pagination: {
          enabled: true,
        }
      },
      1024: {
        slidesPerView: 3,
        pagination: {
          enabled: true,
        }
      },
      1280: {
        slidesPerView: 4,
      },
    },
  };

  function latestPostsSwiperDisplay(e) {
    if( $(window).width() < 1280 ) {
      if( $('.js-latest-posts-slider').length > 0 && !latestPostsSwiper.initialized ) {
        latestPostsSwiper = new Swiper('.js-latest-posts-slider', latestPostsSwiperParams);
      };
    }
    else {
      if( $('.js-latest-posts-slider').length > 0 && latestPostsSwiper.initialized ) {
        latestPostsSwiper.destroy(false,true);
        $('.js-latest-posts-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('#latest-posts-swiper-pagination').hide();
      };
    }
  }

  // Profiles sliders

  let profilesSwiper = document.querySelector('.js-profiles-slider');

  const profilesSwiperParams = {
    slidesPerView: 2,
    slidesPerGroup: 2,
    spaceBetween: 10,
    pagination: {
      enabled: true,
      el: "#profiles-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      768: {
        slidesPerView: 3,
        pagination: {
          enabled: true,
        }
      }
    },
    on: {
      destroy: function() {
        $('.swiper-pagination').hide();
      },
      init: function() {
        $('.swiper-pagination').show();
      },
    },
  };

  function profilesSwiperDisplay(e) {
    if( $(window).width() < 1024 ) {
      if( $('.js-profiles-slider').length > 0 && !profilesSwiper.initialized ) {
        profilesSwiper = new Swiper('.js-profiles-slider', profilesSwiperParams);
      };
    }
    else {
      if( $('.js-profiles-slider').length > 0 && profilesSwiper.initialized ) {
        profilesSwiper.destroy(false,true);
        $('.js-profiles-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('#profiles-swiper-pagination').hide();
      };
    }
  }

  // Related-items sliders

  let productLinesSwiper = document.querySelector('.js-product-lines-slider');

  const productLinesSwiperParams = {
    slidesPerView: 1.1,
    spaceBetween: 24,
    pagination: {
      enabled: true,
      el: "#product-lines-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        navigation: {
          enabled: false,
        },
        pagination: {
          enabled: true,
        }
      },
      1024: {
        slidesPerView: 3,
        navigation: {
          enabled: true,
        },
        pagination: {
          enabled: true,
        }
      },
      1280: {
        slidesPerView: 4,
      }
    },
    on: {
      destroy: function() {
        $('.swiper-pagination').hide();
      },
      init: function() {
        $('.swiper-pagination').show();
      },
    }
  };

  function productLinesSwiperDisplay(e) {
    if( $(window).width() < 1280 ) {
      if( $('.js-product-lines-slider').length > 0 && !productLinesSwiper.initialized ) {
        productLinesSwiper = new Swiper('.js-product-lines-slider', productLinesSwiperParams);
      };
    }
    else {
      if( $('.js-product-lines-slider').length > 0 && productLinesSwiper.initialized ) {
        productLinesSwiper.destroy(false,true);
        $('.js-product-lines-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('#product-lines-swiper-pagination').hide();
      };
    }
  }

  featuresSwiperDisplay();
  benefitsSwiperDisplay();
  relatedPostsSwiperDisplay();
  latestPostsSwiperDisplay();
  profilesSwiperDisplay();
  productLinesSwiperDisplay();

  $(window).resize(function() {
    benefitsSwiperDisplay();
    featuresSwiperDisplay();
    relatedPostsSwiperDisplay();
    latestPostsSwiperDisplay();
    profilesSwiperDisplay();
    productLinesSwiperDisplay();
  })

  // Cards sliders

  const cardsSwiper = new Swiper('.js-cards-slider', {
    slidesPerView: 1.1,
    spaceBetween: 24,
    navigation: {
      enabled: false,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      enabled: true,
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        navigation: {
          enabled: false,
        },
        pagination: {
          enabled: true,
        }
      },
      1024: {
        slidesPerView: 3,
        navigation: {
          enabled: true,
        },
        pagination: {
          enabled: true,
        }
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 32,
        navigation: {
          enabled: true,
        },
        pagination: {
          enabled: false,
        }
      },
    },
  });

  // Related-items sliders

  const relatedItemsSwiper = new Swiper('.js-related-items-slider', {
    slidesPerView: 1.1,
    spaceBetween: 24,
    navigation: {
      enabled: false,
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      enabled: true,
      el: ".swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        navigation: {
          enabled: false,
        },
        pagination: {
          enabled: true,
        }
      },
      1024: {
        slidesPerView: 3,
        navigation: {
          enabled: true,
        },
        pagination: {
          enabled: true,
        }
      },
      1280: {
        slidesPerView: 4,
        spaceBetween: 32,
        navigation: {
          enabled: true,
        },
        pagination: {
          enabled: false,
        }
      },
    },
  });

  // Instagram sliders

  const instagramSwiper = new Swiper('.js-instagram-slider', {
    slidesPerView: 1.4,
    spaceBetween: 10,
    centeredSlides: true,
    loop: true,
    on: {
      init: function () {
        this.updateSlides();
      },
      slideChange: function () {
        this.updateSlides();
      },
      resize: function () {
        this.updateSlides();
      }
    },
    breakpoints: {
      640: {
        slidesPerView: 3,
      },
      1024: {
        slidesPerView: 4,
        spaceBetween: 20,
      },
    },
  });

}
